<footer class="fiber-bg-blue-primary fiber-mt-7">
  <div class="fiber-grid resp-margin">
    <div class="fiber-grid__row">
      <div
        class="fiber-grid__col fiber-grid__col--md-12 fiber-pb-4 fiber-pb-4 fiber-text--color-white"
      >
        <p
          class="fiber-text fiber-text-area fiber-text--size-1 fiber-mt-3 fiber-ta-center"
        >
        Blue Cross and Blue Shield of Illinois, a Division of Health Care Service Corporation, a Mutual Legal Reserve Company,
         an Independent Licensee of the Blue Cross and Blue Shield Association.
        </p>
        <br /> <!-- Add gap between Blue Shield Association and copyright line -->
        <p
          class="fiber-text fiber-text-area fiber-text--size-1 fiber-ta-center"
        >
          © {{ currentYear }} Health Care Service Corporation. All
          Rights Reserved
        </p>
        <br /> <!-- Add gap between copyright and Terms of Use links -->
        <p class="fiber-text fiber-text-area fiber-text--size-1 fiber-ta-center">
          <a href="https://providers.hcsc.net/providers/terms_of_use.html" target="_blank" class="fiber-text--color-white text-underline">Terms of Use</a>
          &nbsp;|&nbsp;
          <a href="https://providers.hcsc.net/providers/important_information.html" target="_blank" class="fiber-text--color-white text-underline">Important Information</a>
        </p>
      </div>
    </div>
  </div>
</footer>
